export default __webpack_public_path__ + "static/char-s-59-zh-Hant-de143cbe8abf92f7b4907c6ea1861da4.png";